import { memo } from 'react';
import { fontSize, fontWeight, spacing } from 'presentations/views/styles';
import { gray04 } from 'presentations/views/styles/color';
import styled from '@emotion/styled';
import AllDayEventCell from '../AllDayEventCell';
import { Props, useAllDayTimeGrid } from './hooks';

const Component = memo((props: Props) => {
  const { state, actions } = useAllDayTimeGrid(props);
  return (
    <Content maxCols={state.dates.length} maxRows={state.maxRow + 1}>
      {Array.from({
        length: state.dates.length * (state.maxRow + 1),
      }).map((_, i) => (
        <HeaderCell key={i} data-all-day={1} data-frame-id={i} />
      ))}
      {!state.isLoading &&
        state.events.map((event) => (
          <AllDayEventCell
            key={event.layoutId}
            eventId={event.eventId}
            x={event.x}
            y={event.y}
            xSpan={event.xSpan}
            ySpan={event.ySpan}
            color={event.color}
            name={event.name}
          />
        ))}
    </Content>
  );
});
const Content = styled.div<{
  height?: number;
  maxRows: number;
  maxCols: number;
}>`
  width: inherit;
  flex: 1 1 0%;
  display: grid;
  grid-template-columns: ${(props) =>
    `repeat(${props.maxCols}, minmax(${props.height || 24}px, 1fr))`};
  grid-template-rows: ${(props) =>
    `repeat(${props.maxRows}, minmax(18px, 1fr))`};
  position: relative;
`;
const HeaderCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid ${gray04};
  font-size: ${fontSize(14)};
  font-weight: ${fontWeight('bold')};
  padding: ${spacing(8)} 0;
`;
export default Component;
